import { useQuery } from '@apollo/client';
import { GetFinancialOverviewResponse, GetFinancialOverviewRequest, CITRIN_GET_FINANCIAL_OVERVIEW } from '..';

export const useGetFinancialOverviewQuery = () => {
    const { data, previousData, ...rest } = useQuery<GetFinancialOverviewResponse, GetFinancialOverviewRequest>(
        CITRIN_GET_FINANCIAL_OVERVIEW
        // fetchPolicy: 'cache-and-network',
        // onCompleted: (data) => console.log('[MGT] Pass', data),
    );

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getFinancialOverview,
        data: data?.CITRIN_MGT_getFinancialOverview ?? [],
    };
};
